import { ROUTE_MY_PROFILE, ROUTE_ORG } from 'constant/routes';
import compose from 'lodash.flowright';
import PropType from 'prop-types';
import injectSheet from 'react-jss';
import { NavLink, withRouter } from 'react-router-dom';

import styles from './pageNavigation.style';

export const PageNavigation = ({ classes, user }) => {
  const MY_PROFILE_LINK = { name: 'My Profile', path: ROUTE_MY_PROFILE };
  const ORGANIZATION_LINK = { name: 'Organization', path: ROUTE_ORG };
  const PAGE_LINKS = [MY_PROFILE_LINK];

  if (user.organizations && user.organizations.nodes.length > 0) {
    PAGE_LINKS.push(ORGANIZATION_LINK);
  }

  return (
    <section className={classes.container}>
      {PAGE_LINKS.map(pageLink => (
        <NavLink
          className={classes.pageLink}
          draggable="false"
          exact={pageLink.path === ROUTE_MY_PROFILE}
          key={pageLink.path}
          to={pageLink.path}
        >
          <p className={classes.linkName}>{pageLink.name}</p>
          <span className={classes.underLine} />
        </NavLink>
      ))}
    </section>
  );
};

PageNavigation.propTypes = {
  classes: PropType.object.isRequired,
  user: PropType.object.isRequired
};

export default compose(withRouter, injectSheet(styles))(PageNavigation);
